// import { useForm } from "react-hook-form"
// import InputsFields from "../../helpers/InputFields";
// import { useCreateAccountMutation, useGetAccountByIdQuery, useUpdateAccountMutation } from "../../store/services/UsersService";
// import { passwordInput, PrivacyAzienda, PrivacyCategorie, Supervisore, UserRegion, UsersListInputs } from "../../utils/listInputs/UsersListInputs";
// import Loader from "../main/Loader";
// import { toast } from "react-toastify";
// import { UserAdapterSent, UserAdapterValues } from "../../helpers/adapter/UserAdapter";
// import { useEffect, useMemo, useRef, useState } from "react";
// import { useSelector } from "react-redux";
// import { selectCurrentUserInfo } from "../../store/feautures/AuthSlice";
// import { skipToken } from '@reduxjs/toolkit/query/react'
// import RegioniLookUp from "../../lookup/Regioni";
// import { useNavigate } from "react-router-dom";
// import { useGetUserRoleQuery } from "../../store/services/LookUpService";
// import { useGetAgenciesQuery } from "../../store/services/AgencyService";
// import { useGetCategoriesQuery } from "../../store/services/CategoryService";
// import RuoliLookUp from "../../lookup/RoleLookup";

// export default function UsersForm({ infoForUpdate, type}: any) {

//     const { data, isLoading } = useGetAccountByIdQuery(infoForUpdate?.id ? infoForUpdate.id : skipToken);
//     const form = useForm();
//     const { handleSubmit, reset, watch, formState: {dirtyFields}, setValue } = form;
//     const [addAccount, { isLoading: isAdding }] = useCreateAccountMutation();
//     const [updateAccount, { isLoading: isUpdating }] = useUpdateAccountMutation();
//     let actionLabel = type === 'add' ? 'aggiunto' : 'modificato';
//     let roleSelected = watch('ruolo');
//     let agencySelected = watch('aziendaId');
//     const { role } = useSelector(selectCurrentUserInfo);
//     const optionRegioni = RegioniLookUp(false);
//     const navigate = useNavigate();
//     const {isLoading: isLoadingAccount, data: accountList} = useGetUserRoleQuery(roleSelected?.value === 'Operatore'  ? {role: 'Supervisore'} : skipToken)
//     const [listSuperVi, setListSuperV] = useState([]);
//     const roleList = RuoliLookUp();

//     // Privacy
//     const firstRenderRef = useRef(true);
//     const {data: dataAziende, isLoading: isLoadingAz}: any = useGetAgenciesQuery({isSelect: true});
//     const {data: dataCategorie, isLoading: isLoadingCat}: any = useGetCategoriesQuery(
//         type === 'update' && firstRenderRef.current
//         ? data?.result.aziendaId ? {idAzienda: data.result.aziendaId, isSelect: true} : skipToken
//         : agencySelected?.value ? {idAzienda: agencySelected.value, isSelect: true} : skipToken
//     );

//     let aziendaLista: any = useMemo(() => {
//         return dataAziende?.result?.map((az: any) => ({value: az.id, label: az.nome}))
//     }, [dataAziende]);

//     let categoriaLista: any = useMemo(() => {
//         return dataCategorie?.result?.map((cat: any) => ({value: cat.id, label: cat.nome}))
//     }, [dataCategorie])    

//     useEffect(() => {
//         let listMap = accountList?.map((acc: any) => {
//             return {value: acc?.id, label: acc?.nominativo }
//         });

//         setListSuperV(listMap);
//     }, [accountList]);

//     // Se cambia l'azienda setto il valore categoria a vuoto
//     useEffect(() => {
//         agencySelected?.value && dirtyFields.agenziaId && setValue('categoriaLavoratoreId', '');
//     }, [agencySelected, dirtyFields])

//     // Se è unpdate valorizzo il form solo la prima volta
//     useEffect(() => {
//         if(!isLoadingAz && !isLoadingCat && firstRenderRef.current && !dirtyFields.aziendaId && data) {
//             const mapInfo = UserAdapterValues(data?.result, listSuperVi, aziendaLista, categoriaLista);
//             reset(mapInfo);
//             firstRenderRef.current = false;
//         }
//     }, [data, aziendaLista, categoriaLista, dirtyFields, isLoadingAz, isLoadingCat]);

//     useEffect(() => {
//         return(() => {firstRenderRef.current = true})
//     }, []);

//     const handleSubmitUserData = async (data: any) => {
//         let result: any;
//         let objMap = UserAdapterSent(data);

//         if (type === 'add') {
//             result = await addAccount(objMap);
//         }

//         if (type === 'update') {
//             result = await updateAccount({ id: infoForUpdate?.id, ...objMap });
//         }

//         if ('error' in result) {
//             toast.error(`Utente non ${actionLabel}! Errore: ${result?.error?.data?.detail}`)
//         } else {
//             toast.success(`Utente ${actionLabel}`)
//             navigate('/dashboard/users')
//         }
//     }

//     return (
//         <>
//             {(isUpdating || isAdding || isLoading || isLoadingAccount || isLoadingAz || isLoadingCat) && <Loader />}
//             <form onSubmit={handleSubmit(handleSubmitUserData)} className="my-6">
//                 <div className="grid grid-cols-2 grid-rows-none gap-10 p-10">
//                     <InputsFields arrFields={UsersListInputs(roleList, type === 'update' ? true : false)} form={form} />
//                     {roleSelected?.value === 'Operatore' ? <InputsFields arrFields={Supervisore(listSuperVi)} form={form} /> : null}
//                     {roleSelected?.value === 'Consulente' || roleSelected?.value === 'Speaker' ? <InputsFields arrFields={UserRegion(optionRegioni)} form={form} /> : null}
//                     {type !== 'update' &&
//                         <div>
//                             <InputsFields arrFields={passwordInput} form={form} />
//                             <ul className="list-none text-sm my-4">
//                                 <li>- almeno 6 caratteri</li>
//                                 <li>- almeno 1 non alfanumerico</li>
//                                 <li>- almeno 1 digit (0-9)</li>
//                                 <li>- almeno una maiuscola</li>
//                             </ul>
//                         </div>
//                     }

//                     {/* Privacy */}
//                     {type === 'add' && <div></div>}
//                     <InputsFields arrFields={PrivacyAzienda(aziendaLista)} form={form} />
//                     {!isLoadingCat && <InputsFields arrFields={PrivacyCategorie(categoriaLista)} form={form} /> }
//                 </div>

//                 <div className="flex justify-end my-8 p-10">
//                     <button className="h-10 bg-[#064e3b] text-white px-5 w-64 rounded-lg text-md">Salva</button>
//                 </div>
//             </form>
//         </>

//     )
// }



// Nuova logica 


import { useForm } from "react-hook-form"
import InputsFields from "../../helpers/InputFields";
import { useCreateAccountMutation, useGetAccountByIdQuery, useUpdateAccountMutation } from "../../store/services/UsersService";
import { OperatoreRegioniField, passwordInput, PrivacyAzienda, PrivacyCategorie, Supervisore, UserRegion, UsersListInputs } from "../../utils/listInputs/UsersListInputs";
import Loader from "../main/Loader";
import { toast } from "react-toastify";
import { UserAdapterSent, UserAdapterValues } from "../../helpers/adapter/UserAdapter";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { skipToken } from '@reduxjs/toolkit/query/react'
import RegioniLookUp from "../../lookup/Regioni";
import { useNavigate } from "react-router-dom";
import { useGetUserRoleQuery } from "../../store/services/LookUpService";
import { useGetAgenciesQuery } from "../../store/services/AgencyService";
import { useGetCategoriesQuery } from "../../store/services/CategoryService";
import RuoliLookUp from "../../lookup/RoleLookup";
import { SuperAndAdminAdvance } from "../../utils/genericList/ListRoleRoutes";
import { selectCurrentUserInfo } from "../../store/feautures/AuthSlice";

export default function UsersForm({ infoForUpdate, type }: any) {

    const { role } = useSelector(selectCurrentUserInfo);
    const { data, isLoading } = useGetAccountByIdQuery(infoForUpdate?.id ? infoForUpdate.id : skipToken);
    const form = useForm();
    const { handleSubmit, reset, watch, formState: { dirtyFields }, setValue } = form;
    const [addAccount, { isLoading: isAdding }] = useCreateAccountMutation();
    const [updateAccount, { isLoading: isUpdating }] = useUpdateAccountMutation();

    const actionLabel = type === 'add' ? 'aggiunto' : 'modificato';
    const roleSelected = watch('ruolo');
    const agencySelected = watch('aziendaId');

    const optionRegioni = RegioniLookUp(false);
    const navigate = useNavigate();

    const { isLoading: isLoadingAccount, data: accountList } = useGetUserRoleQuery(roleSelected?.value === 'Operatore' ? { role: 'Supervisore' } : skipToken);
    const [listSuperVi, setListSuperV] = useState([]);
    const roleList = RuoliLookUp();

    // Privacy
    const firstRenderRef = useRef(true);
    const { data: dataAziende, isLoading: isLoadingAz }: any = useGetAgenciesQuery({ isSelect: true });
    const { data: dataCategorie, isLoading: isLoadingCat }: any = useGetCategoriesQuery(
        type === 'update' && firstRenderRef.current
            ? data?.result.aziendaId ? { idAzienda: data.result.aziendaId, isSelect: true } : skipToken
            : agencySelected?.value ? { idAzienda: agencySelected.value, isSelect: true } : skipToken
    );

    const aziendaLista: any = useMemo(() => {
        return dataAziende?.result?.map((az: any) => ({ value: az.id, label: az.nome }))
    }, [dataAziende]);

    const categoriaLista: any = useMemo(() => {
        return dataCategorie?.result?.map((cat: any) => ({ value: cat.id, label: cat.nome }))
    }, [dataCategorie]);

    useEffect(() => {
        const listMap = accountList?.map((acc: any) => ({
            value: acc?.id,
            label: acc?.nominativo
        }));
        setListSuperV(listMap);
    }, [accountList]);

    // Reset categoria se cambia azienda
    useEffect(() => {
        agencySelected?.value && dirtyFields.agenziaId && setValue('categoriaLavoratoreId', '');
    }, [agencySelected, dirtyFields]);

    // Valorizzo form solo una volta su update
    useEffect(() => {
        if (!isLoadingAz && !isLoadingCat && firstRenderRef.current && !dirtyFields.aziendaId && data) {
            const mapInfo = UserAdapterValues(data?.result, listSuperVi, aziendaLista, categoriaLista, optionRegioni);
            reset(mapInfo);
            firstRenderRef.current = false;
        }
    }, [data, aziendaLista, categoriaLista, dirtyFields, isLoadingAz, isLoadingCat]);

    useEffect(() => {
        return () => { firstRenderRef.current = true }
    }, []);

    const handleSubmitUserData = async (data: any) => {
        let result: any;
        let objMap = UserAdapterSent(data);

        if (type === 'add') {
            result = await addAccount(objMap);
        } else {
            result = await updateAccount({ id: infoForUpdate?.id, ...objMap });
        }

        if ('error' in result) {
            toast.error(`Utente non ${actionLabel}! Errore: ${result?.error?.data?.detail}`);
        } else {
            toast.success(`Utente ${actionLabel}`);
            navigate('/dashboard/users');
        }
    }

    return (
        <>
            {(isUpdating || isAdding || isLoading || isLoadingAccount || isLoadingAz || isLoadingCat) && <Loader />}
            <form onSubmit={handleSubmit(handleSubmitUserData)} className="my-6">
                <div className="grid grid-cols-2 grid-rows-none gap-10 p-10">

                    {/* Campi utente base */}
                    <InputsFields arrFields={UsersListInputs(roleList, type === 'update')} form={form} />

                    {/* Se è un Operatore → mostra supervisore e regioni */}
                    {roleSelected?.value === 'Operatore' && (
                        <>
                            <InputsFields arrFields={Supervisore(listSuperVi)} form={form} />
                            {/* nuova multiselect regioni */}
                            { SuperAndAdminAdvance.includes(role) && <InputsFields arrFields={OperatoreRegioniField(optionRegioni)} form={form} /> }
                        </>
                    )}

                    {/* --- CONSULENTE / SPEAKER --- */}
                    {(roleSelected?.value === 'Consulente' || roleSelected?.value === 'Speaker') && (
                        <InputsFields arrFields={UserRegion(optionRegioni)} form={form} />
                    )}

                    {/* Password solo in creazione */}
                    {type !== 'update' && (
                        <div>
                            <InputsFields arrFields={passwordInput} form={form} />
                            <ul className="list-none text-sm my-4">
                                <li>- almeno 6 caratteri</li>
                                <li>- almeno 1 non alfanumerico</li>
                                <li>- almeno 1 digit (0-9)</li>
                                <li>- almeno una maiuscola</li>
                            </ul>
                        </div>
                    )}

                    {/* Privacy */}
                    <InputsFields arrFields={PrivacyAzienda(aziendaLista)} form={form} />
                    {!isLoadingCat && <InputsFields arrFields={PrivacyCategorie(categoriaLista)} form={form} />}
                </div>

                <div className="flex justify-end my-8 p-10">
                    <button className="h-10 bg-[#064e3b] text-white px-5 w-64 rounded-lg text-md">Salva</button>
                </div>
            </form>
        </>
    );
}
